import { RouteDefinition } from "@solidjs/router";
import { lazy } from "solid-js";

import { AccessRoleEditNav } from "../components/access-control/AccessRoleEditNav.js";
import { catchAll } from "./catch-all.routes.js";

const accessRoleChildren = (parent: string) => [
  catchAll(`${parent}/users`),
  {
    path: "/users",
    component: lazy(
      () => import("../components/access-control/AccessRoleUsersList.js"),
    ),
  },
  {
    path: "/permissions",
    component: lazy(
      () => import("../components/access-control/AccessRolePermissionsList.js"),
    ),
  },
];

export const accessControlRoutes: RouteDefinition[] = [
  {
    path: "/access-control",
    children: [
      {
        path: "/",
        component: lazy(
          () => import("../components/access-control/AccessRolesList.js"),
        ),
      },
      {
        path: "/:id/*",
        component: AccessRoleEditNav,
        children: accessRoleChildren("/access-control/:id/users"),
      },
    ],
  },
];
